
import { useEffect } from 'react'
import Select from 'react-select'
import { EquipmentNameDDLAPI, EquipmentTypeDDLAPI, EquipmentWorkDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const EquipmentWorkDataDDL = (props) => {
    const { EquipmentWork, setEquipmentWork, ScreenName, WorkPeriod,EquipmentName,IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    // console.log(WardName.ID)
    useEffect(() => {
        const data = {
            M_STP_EquipmentMasterID: EquipmentName.ID,
            M_STP_WorkPeriodID: WorkPeriod,
            M_UserID: UserID,
            token: token,
        }
        if(EquipmentName.ID !== 0){
        dispatch(EquipmentWorkDDLAPI({ data }))
        }
    }, [EquipmentName.ID,IsPost ])

    const { EquipmentWorkData } = useSelector(state => state.EquipmentWorkDDL)

    useEffect(() => {
        handleSTPEquipmentWorkDDL()
    }, [EquipmentWorkData])

    const handleSTPEquipmentWorkDDL = () => {
        // console.log(DeptDDLDataa)
        if (EquipmentWorkData && EquipmentWorkData.table && EquipmentWorkData.table.length > 0) {
            let list = EquipmentWorkData.table.map((item, index) => ({
                value: item.m_stP_EquipmentWorkID,
                label: item.equipmentName,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setEquipmentWork({ ...EquipmentWork, DDL: list })
        }
        else {
            setEquipmentWork({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Equipment Work </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: EquipmentWork.ID, label: EquipmentWork.Label }}
                onChange={(e) => {
                    e ?
                        setEquipmentWork({ ...EquipmentWork, ID: e.value, Label: e.label })
                        :
                        setEquipmentWork({ ...EquipmentWork, ID: 0, Label: "Select..." })

                }}
                options={EquipmentWork.DDL}
            />
        </div>
    )
}